import { render } from "./doctor-login.vue?vue&type=template&id=9e8e02d0&scoped=true"
import script from "./doctor-login.vue?vue&type=script&lang=js"
export * from "./doctor-login.vue?vue&type=script&lang=js"

import "./doctor-login.vue?vue&type=style&index=0&id=9e8e02d0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e8e02d0"]])

export default __exports__